module.exports = __webpack_public_path__ + "static/truck-1271f18d5097db1613336fe8b773fb65.svg";